import {
    createRequestTypes,
    START,
    SUCCESS,
    ERROR,
  } from '@modules/appraisal/actions/global';
  import { makeApiActionCreatorV3 } from '@actions/utils';
  import * as api from '@modules/appeals/api/appealsPanel';
  
  const namespace = 'APPEALS/APPEAL-PANEL';
  
  export const FETCH_APPEAL_PANEL_OVERVIEW = createRequestTypes(
    `${namespace}/FETCH_APPEAL_PANEL_OVERVIEW`,
  );
  
  export const fetchAppealPanelOverview = makeApiActionCreatorV3(
    api.fetchAppealPanelOverview,
    FETCH_APPEAL_PANEL_OVERVIEW[START],
    FETCH_APPEAL_PANEL_OVERVIEW[SUCCESS],
    FETCH_APPEAL_PANEL_OVERVIEW[ERROR],
  );

  export const FETCH_APPEAL_PANEL_STATUS = createRequestTypes(
    `${namespace}/FETCH_APPEAL_PANEL_STATUS`,
  );
  
  export const fetchAppealPanelStatus = makeApiActionCreatorV3(
    api.fetchAppealPanelStatus,
    FETCH_APPEAL_PANEL_STATUS[START],
    FETCH_APPEAL_PANEL_STATUS[SUCCESS],
    FETCH_APPEAL_PANEL_STATUS[ERROR],
  );

  export const UPDATE_APPEAL_PANEL_STATUS = createRequestTypes(
    `${namespace}/UPDATE_APPEAL_PANEL_STATUS`,
  );
  
  export const updateAppealPanelStatus = makeApiActionCreatorV3(
    api.updateAppealPanelStatus,
    UPDATE_APPEAL_PANEL_STATUS[START],
    UPDATE_APPEAL_PANEL_STATUS[SUCCESS],
    UPDATE_APPEAL_PANEL_STATUS[ERROR],
  );
  
  export const FETCH_APPEAL_PANEL_STATUS_CODE = createRequestTypes(
    `${namespace}/FETCH_APPEAL_PANEL_STATUS_CODE`,
  );
  
  export const fetchAppealPanelStatusCode = makeApiActionCreatorV3(
    api.fetchAppealPanelStatusCode,
    FETCH_APPEAL_PANEL_STATUS_CODE[START],
    FETCH_APPEAL_PANEL_STATUS_CODE[SUCCESS],
    FETCH_APPEAL_PANEL_STATUS_CODE[ERROR],
  );